import { SectionHeading } from "@/components/shared/SectionHeading";
import { RevealStagger, RevealItem, Reveal } from "@/components/shared/Reveal";
import { Truck, Users, Repeat, HandHelping, LifeBuoy, CaravanIcon, ArrowRightLeft, Warehouse, ArrowRight } from "lucide-react";
import { openPreRegister } from "@/lib/preRegisterModal";

const OPPORTUNITY_TYPES = [
  { icon: Truck, title: "Truck Driving Assignments" },
  { icon: Users, title: "Relief Driver Assignments" },
  { icon: Repeat, title: "Relay Opportunities" },
  { icon: HandHelping, title: "Owner Operator Driver Help" },
  { icon: LifeBuoy, title: "RV Rescue" },
  { icon: CaravanIcon, title: "RV Delivery" },
  { icon: ArrowRightLeft, title: "Dealer Transfers" },
  { icon: Warehouse, title: "Fleet Repositioning" },
];

export const OpportunityTypes = () => (
  <section id="opportunities" data-testid="opportunity-types-section" className="py-24 md:py-32 bg-rr-surface">
    <div className="max-w-6xl mx-auto px-5 md:px-8">
      <SectionHeading eyebrow="Coming to the Marketplace" title="What Opportunities Will Be Available?" align="center" testId="opportunity-types" />

      <RevealStagger className="mt-14 grid sm:grid-cols-2 md:grid-cols-4 gap-4">
        {OPPORTUNITY_TYPES.map((o) => (
          <RevealItem key={o.title}>
            <div
              data-testid={`opportunity-type-${o.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="bg-white border border-rr-line rounded-2xl p-6 h-full flex flex-col items-start gap-4 hover:border-rr-orange/50 hover:-translate-y-1 transition-all"
            >
              <div className="w-11 h-11 rounded-full bg-rr-navy/5 flex items-center justify-center text-rr-orange">
                <o.icon size={20} />
              </div>
              <h3 className="font-heading font-bold text-rr-navy text-sm leading-snug">{o.title}</h3>
            </div>
          </RevealItem>
        ))}
      </RevealStagger>

      <Reveal delay={0.2}>
        <div className="mt-12 text-center">
          <button
            onClick={() => openPreRegister("driver")}
            data-testid="get-notified-opportunities-cta"
            className="inline-flex items-center gap-2 bg-rr-navy text-white font-bold px-8 py-4 rounded-full hover:bg-rr-orange transition-all hover:-translate-y-1"
          >
            Get Notified About Opportunities <ArrowRight size={18} />
          </button>
        </div>
      </Reveal>
    </div>
  </section>
);
